import React, { useState } from "react";
import "./MySkillsPart.css";
import { Skill } from "../../types";
import MySkillsListElement from "../mySkillsListElement/MySkillsListElement";
import { getSkillsImageUrl } from "../../utils/cloudinary";
import skills from "../../static/skills_content.json";

// Cloudinary URLs for images
const programming_wallpaper = getSkillsImageUrl('programming_wallpaper');
const skills_list_arrow = getSkillsImageUrl('skills_list_arrow');

const MySkillsPart = () => {
    const [showArrow, setShowArrow] = useState(true);
    const [isHovered, setIsHovered] = useState(false);
    const [hasFlashPlayed, setHasFlashPlayed] = useState(false);
    const [isFlashing, setIsFlashing] = useState(false);

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const scrollTop = e.currentTarget.scrollTop;
        setShowArrow(scrollTop < 20);
    };

    const handleMouseEnter = () => {
        setIsHovered(true);
        if (!hasFlashPlayed) {
            setIsFlashing(true);
            setHasFlashPlayed(true);
            // Reset the flash state after animation completes
            setTimeout(() => {
                setIsFlashing(false);
            }, 800); // Duration should match CSS animation duration
        }
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div className="my-skills-part-container">
            <div className="my-skills-part-content-container">
                <div className="my-skills-part-left-container">
                    <p className="my-skills-part-left-container-title">
                        MY SKILLS
                    </p>
                    <div className="my-skills-part-left-container-image-container">
                        <img
                            src={programming_wallpaper}
                            alt="my-skills"
                            className="my-skills-part-left-container-image"
                        />
                    </div>
                </div>
                <div className="my-skills-part-right-container">
                    <div
                        className={`my-skills-part-right-container-scrollable-list-container ${
                            isFlashing ? "flash-animation" : ""
                        }`}
                        onScroll={handleScroll}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        {skills.map((skill: Skill, index: number) => (
                            <MySkillsListElement
                                key={skill.name}
                                skill={skill}
                                isLast={index === skills.length - 1}
                            />
                        ))}
                    </div>
                    <img
                        src={skills_list_arrow}
                        alt="scroll indicator"
                        className={`skills-list-arrow ${
                            showArrow ? "visible" : ""
                        } ${isHovered ? "hovered" : ""}`}
                    />
                </div>
            </div>
        </div>
    );
};

export default MySkillsPart;
